import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import categoryOrder from 'Enums/categoryOrder'
import { apiUrl } from 'Services/accessUrl'

const endpoint = `${apiUrl.stable}/empresas`

/**
 * Return the categort information with a localized company list
 * @param {object} slug
 * @param {string} slug.category
 * @param {string} slug.serviceType
 * @param {string} slug.region
 * @param {object} [query]
 * @param {number} [query.page]
 * @param {number} [query.pagesize]
 * @param {number} [query.sort]
 * @param {number} [query.filter]
 * @returns {Promise.<{ data: ApiCategoryDirectory }>}
 */
export const getDirectory = ({ serviceType, region}, query = {}) => {

  const latitude = parseFloat(sessionStorage.getItem('user_latitude') || '');
  const longitude = parseFloat(sessionStorage.getItem('user_longitude') || '');
  const hasLocation = !isNaN(latitude) && !isNaN(longitude);

  const url = hasLocation && query['sort'] == categoryOrder.proximity
    ? `${endpoint}/${serviceType}/${region}/${latitude}/${longitude}`
    : `${endpoint}/${serviceType}/${region}`

    console.log('getDirectory', url)
  const params = {
    pageSize: 20,
    ...query
  }

  return axios.get(url, { params })
}


/**
 * Return the category information with the user's favorite companies
 * @param {object} slug
 * @param {string} slug.category
 * @param {string} slug.serviceType
 * @param {string} slug.region
 * @param {object} [query]
 * @param {number} [query.page]
 * @param {number} [query.pagesize]
 * @param {number} [query.sort]
 * @param {number} [query.filter]
 * @returns {Promise.<{ data: ApiCategoryDirectory }>}
 */
export const getFavoriteDirectory = ({ serviceType, region }, query = {}) => {

  const latitude = parseFloat(sessionStorage.getItem('user_latitude') || '');
  const longitude = parseFloat(sessionStorage.getItem('user_longitude') || '');
  const hasLocation = !isNaN(latitude) && !isNaN(longitude);

  const url = hasLocation && query['sort'] == categoryOrder.proximity
    ? `${endpoint}/${serviceType}/${region}/${latitude}/${longitude}/favoritos`
    : `${endpoint}/${serviceType}/${region}/favoritos`

  const headers = { ...jsonWebToken.header }

  let params = {
    pageSize: 20,
    ...query
  }

  return axios.get(url, { headers, params })
}

/**
 * @returns {Promise.<{ data: ApiCategoryReview }>}
 */
export const getReviews = () => {
  const url = `${endpoint}/avaliacoes`

  return axios.get(url)
}

export default {
  getDirectory,
  getFavoriteDirectory,
}